// App.js - Version améliorée
import React, { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Main from './layouts/Main';
import NotFound from "./pages/NotFound";
import Signin from "./pages/Signin2";
import PrivateRoute from "./components/PrivateRoute";
import { Spinner } from "react-bootstrap";
import { initTaxes } from './utils/taxesHelper';
import publicRoutes from "./routes/PublicRoutes";
import protectedRoutes from "./routes/ProtectedRoutes";

import "./assets/css/remixicon.css";
import "./scss/style.scss";



// set skin on load
window.addEventListener("load", function () {
  let skinMode = localStorage.getItem("skin-mode");
  let HTMLTag = document.querySelector("html");

  if (skinMode) {
    HTMLTag.setAttribute("data-skin", skinMode);
  }
});

export default function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
     initTaxes();
    // Simuler un petit délai pour que tout soit chargé
    const timer = setTimeout(() => setInitialized(true), 100);
    return () => clearTimeout(timer);
  }, []);

  if (!initialized) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <Spinner animation="border" variant="primary" />
        <span className="ms-3">Initialisation de l'application...</span>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/pages/signin2" replace />} />
        <Route path="/login" element={<Navigate to="/pages/signin2" replace />} />
        <Route path="/pages/signin2" element={<Signin />} />

        {publicRoutes && publicRoutes.map((route, index) => (
          <Route
            path={route.path}
            element={route.element}
            key={`public-${index}`}
          />
        ))}

        <Route 
          path="/" 
          element={
            <PrivateRoute>
              <Main />
            </PrivateRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          
          {protectedRoutes && protectedRoutes.map((route, index) => (
            <Route
              path={route.path}
              element={route.element}
              key={`protected-${index}`}
            />
          ))}
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}